import React from 'react';
import PIRCollectionRequestsList from "../../PIR/page/PIRCollectionRequestsList";
import IcrHeader from './IcrHeader';
import {Stack} from "@mui/material";

const ListOfInformationCollectionRequests = () => {
    return (
        <Stack>
            <IcrHeader pirId={null}/>
            <Stack p={2}>
                <PIRCollectionRequestsList pirId={null}/>
            </Stack>
        </Stack>
    );
};

export default ListOfInformationCollectionRequests;